import { auth } from '@/services/firebase/init'
import { reportError } from '@/services/utils/telemetry'

const getFirebaseTokenHeader = async () => {
  try {
    const token = await auth.currentUser.getIdToken(true)
    return { 'Firebase-Token': `Bearer ${token}` }
  } catch (error) {
    reportError(error)
    console.error('Error getting token:', error)
    throw error
  }
}

export const getOciHeaders = async () => {
  return {
    'Content-Type': 'application/json',
    ...(await getFirebaseTokenHeader()),
  }
}

export const getOciOptions = async (method, payload) => {
  const headers = await getOciHeaders()
  return {
    method,
    mode: 'cors',
    headers,
    ...(payload && { body: JSON.stringify(payload) }),
  }
}

export const fechApiWithAuthToken = async ({ method, url, payload }) => {
  const options = await getOciOptions(method, payload)
  return await fetch(url, options)
}

export const fetchOciApiJson = async ({ endPoint, method, payload }) => {
  const fetchResult = {
    data: null,
    errorText: '',
    status: null,
  }
  const options = await getOciOptions(method, payload)
  const response = await fetch(endPoint, options)
  if (!response.ok) {
    const errorText = await response.text()
    reportError(errorText, {
      endPoint,
      method,
      payload: JSON.stringify(payload),
    })
    return { ...fetchResult, errorText, status: response.status }
  }
  const data = await response.json()
  return { ...fetchResult, data }
}
